import Tagify from "@yaireo/tagify";
import _ from "lodash";

const suggestionCount = 60;

export const SingleSelectHook = {
  mounted() {
    renderInput(this.el, this);
  },
};

function renderInput(el, hook) {
  const input = el.querySelector("input");
  $(".tagify-prerender", el).hide();
  let options = [];

  if (el.dataset.options) {
    options = JSON.parse(el.dataset.options);
  }

  let placeAbove;
  if (el.dataset.dropdownPlacement === "above") {
    placeAbove = true;
  }
  if (el.dataset.dropdownPlacement === "below") {
    placeAbove = false;
  }

  const tagify = new Tagify(input, {
    mode: "select",
    tagTextProp: "value",
    dropdown: {
      enabled: 0,
      highlightFirst: true,
      maxItems: suggestionCount,
      placeAbove: placeAbove,
    },
    whitelist: options,
    enforceWhitelist: true,
    originalInputValueFormat: (value) => {
      if ("optionsPreserveValue" in el.dataset) {
        return JSON.stringify(value);
      }
      return value.map((v) => v.id).join(",");
    },
    templates: {
      dropdownItem: function (tagData) {
        return `<div ${this.getAttributes(tagData)} class='tagify__dropdown__item ${
          tagData.class ? tagData.class : ""
        }' >
        ${
          tagData.icon ? `<i·class="px-2${tagData.icon}"></i>` : ""
        }<span>${tagData.value}</span></div>`;
      },
    },
  });

  if ("hideClearButton" in el.dataset) {
    const btnClass = "tagify__tag__removeBtn";
    el.getElementsByClassName(btnClass)[0].style.visibility = "hidden";
    tagify.on("add", () => {
      el.getElementsByClassName(btnClass)[0].style.visibility = "hidden";
    });
  }

  // to be able to call tagify methods later on
  input.tagify = tagify;

  if (el.dataset.optionsPhxEvent) {
    const phxLoadEvent = el.dataset.optionsPhxEvent;
    const inputHandler = _.debounce((e) => {
      let payload = e.detail?.value ?? "";
      // pushEvent should send an object, please use this option.
      if (el.dataset.optionsPhxPayload) {
        payload = { [el.dataset.optionsPhxPayload]: payload };
      }
      if (el.dataset.optionsPhxTarget) {
        hook.pushEventTo(el.dataset.optionsPhxTarget, phxLoadEvent, payload);
      } else {
        hook.pushEvent(phxLoadEvent, payload);
      }
    }, 500);

    tagify.on("input", inputHandler);

    hook.handleEvent(phxLoadEvent, (data) => {
      // timeout to workaround a Tagify race condition when the total load_event roundtrip
      // is a bit too fast
      setTimeout(() => {
        const receivedOptions = _.take(
          _.sortBy(JSON.parse(data.options), "value"),
          suggestionCount,
        );
        let newWhitelist = _.unionBy([tagify.value], receivedOptions, "id");
        newWhitelist = _.sortBy(newWhitelist, "value");
        newWhitelist = _.reject(newWhitelist, (i) => _.isUndefined(i) || _.isEmpty(i));
        tagify.settings.whitelist = newWhitelist;
        tagify.loading(false).dropdown.show.call(tagify);
      }, 100);
    });
  }
}
